/* tslint:disable */

declare var Object: any;
export interface SFShiftScheduleSF6Interface {
  "id"?: number;
}

export class SFShiftScheduleSF6 implements SFShiftScheduleSF6Interface {
  "id": number;
  constructor(data?: SFShiftScheduleSF6Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFShiftScheduleSF6`.
   */
  public static getModelName() {
    return "SFShiftScheduleSF6";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFShiftScheduleSF6 for dynamic purposes.
  **/
  public static factory(data: SFShiftScheduleSF6Interface): SFShiftScheduleSF6{
    return new SFShiftScheduleSF6(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFShiftScheduleSF6',
      plural: 'SFShiftScheduleSF6s',
      path: 'SFShiftScheduleSF6s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFShiftScheduleSF6.ts